<template>
  <div class="host page">
    <DataTable
      title="Доктора"
      :service="service"
      :options="options"
      :fields="tableFileds"
      :scheme="scheme"
      :pageSize="5"
    />
  </div>
</template>

<script>
import DataTable from '@app/components/uikit/DataTable';
import {
  doctorApi,
  employeeApi,
  specialtyApi,
  departmentApi
} from '@app/services';

export default {
  components: { DataTable },
  data: () => ({
    service: doctorApi,
    options: {
      employees: {
        getLabel: value => ({
          value: value.id,
          label: `${value.lastName} ${value.firstName} ${value.middleName}`
        }),
        getValues: async search => {
          const items = await employeeApi.getAll(20, 0, search);
          return items;
        }
      },
      specialties: {
        getLabel: value => ({ value: value.id, label: value.title }),
        getValues: search => specialtyApi.getAll(20, 0, search)
      },
      departments: {
        getLabel: value => ({ value: value.id, label: value.title }),
        getValues: search => departmentApi.getAll(20, 0, search)
      }
    },
    scheme: {
      controls: {
        employee: {
          type: 'autocomplete',
          label: 'Сотрудник',
          optionName: 'employees',
          placeholder: 'Введите сотрудника...'
        },
        specialty: {
          type: 'autocomplete',
          label: 'Специальность',
          optionName: 'specialties',
          placeholder: 'Введите специальность...'
        },
        department: {
          type: 'autocomplete',
          label: 'Департамент',
          optionName: 'departments',
          placeholder: 'Введите департамент...'
        },
        degree: {
          type: 'text',
          label: 'Квалификация',
          placeholder: 'Введите квалификацию...'
        },
        experience: {
          type: 'text',
          label: 'Стаж',
          placeholder: 'Введите стаж...'
        },
        shortinfo: {
          type: 'textarea',
          label: 'Краткая описание',
          placeholder: 'Введите описание...',
          rows: 3
        },
        fullinfo: {
          type: 'textarea',
          label: 'Полное описание',
          placeholder: 'Введите описание...',
          rows: 5
        }
      }
    },
    tableFileds: [
      {
        name: 'employee',
        label: 'ФИО',
        value: value =>
          `${value.employee.lastName} ${value.employee.firstName} ${value.employee.middleName}`
      },
      {
        name: 'specialty',
        label: 'Специальность',
        value: value => value.specialty.title
      },
      {
        name: 'department',
        label: 'Департамент',
        value: value => value.department.title
      }
    ]
  })
};
</script>